import { Outlet } from 'react-router-dom';

const StudentAssessmentLayout = () => {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 font-sans selection:bg-blue-100 selection:text-blue-900">
            {/* Minimal Header */}
            <header className="h-14 bg-white dark:bg-[#0f1221] border-b border-gray-200 dark:border-white/10 flex items-center justify-center px-4 fixed top-0 w-full z-10 shadow-sm">
                <div className="flex items-center gap-2 opacity-80">
                    <div className="w-6 h-6 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-xs shadow-sm">S</div>
                    <span className="font-bold text-sm tracking-tight text-gray-900 dark:text-gray-100">Sonoma Assessment</span>
                </div>
            </header>

            {/* Main Content Area */}
            <main className="pt-20 pb-10 px-4 md:px-0 max-w-4xl mx-auto">
                <Outlet />
            </main>

            {/* Footer Removed as per request */}
        </div>
    );
};

export default StudentAssessmentLayout;
